"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var SignatureSlot_1 = require("../EsignComponents/SignatureSlot/SignatureSlot");
var inversify_react_1 = require("inversify-react");
var AcceptersDataStore_1 = require("@CommonFrontend/AcceptFlow/AcceptersDataStore");
var DIProvider_1 = __importStar(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var mobx_react_1 = require("mobx-react");
var AcceptFlowGlobalStore_1 = __importDefault(require("@CommonFrontend/AcceptFlow/AcceptFlowGlobalStore"));
var styles = __importStar(require("./Signature.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var dynamic_1 = require("@vanilla-extract/dynamic");
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var GuidedFlowStore_1 = require("@CommonFrontend/GuidedFlow/GuidedFlowStore");
var SignatureWidget = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var _c;
    var attributes = _a.attributes, isPrintMode = _a.isPrintMode, widgetId = _a.widgetId;
    var acceptStore = (0, inversify_react_1.useInjection)("acceptersDataStore");
    var acceptDisabledService = (0, inversify_react_1.useOptionalInjection)("acceptDisabledService");
    var globalStore = AcceptFlowGlobalStore_1.default.getInstance();
    var guidedFlowStore = (0, inversify_react_1.useInjection)("guidedFlowStore");
    var _d = __read((0, react_1.useState)((_c = acceptDisabledService === null || acceptDisabledService === void 0 ? void 0 : acceptDisabledService.isDisabled()) !== null && _c !== void 0 ? _c : false), 2), isAcceptedInCurrentSession = _d[0], setIsAcceptedInCurrentSession = _d[1];
    var appEvents = (0, inversify_react_1.useInjection)("appEvents");
    var handleAccepted = function () {
        setIsAcceptedInCurrentSession(true);
    };
    (0, react_1.useEffect)(function () {
        appEvents.on("accepted", handleAccepted);
        return function () {
            appEvents.removeListener("accepted", handleAccepted);
        };
    }, [appEvents]);
    var storeIndex = AcceptFlowGlobalStore_1.default.getInstance().getAllDataStores().indexOf(acceptStore);
    var handleChangeSignature = function (data, slotIndex) {
        globalStore.updateTargetSignatureAndFilledStores({
            slotIndex: slotIndex,
            storeIndex: storeIndex,
            signature: data.signature,
            method: data.method,
        });
        !!widgetId && guidedFlowStore.updateStep(widgetId, { completed: !!data.signature });
    };
    var handleClearSignature = function (index) {
        acceptStore.clearSignature(index);
        !!widgetId && guidedFlowStore.updateStep(widgetId, { completed: false });
    };
    var handleSlotClick = function (index) {
        globalStore.copySignatureFromOtherStores(index, acceptStore);
        !!widgetId && guidedFlowStore.updateStep(widgetId, { completed: true });
    };
    var isSlotFilledAnywhere = function (index) {
        return globalStore.isSlotFilledInAnyStore(index, "signature");
    };
    var useMaxCol = isPrintMode;
    var maxColumnCount = acceptStore.accepterSlots.length > 2 ? "3" : "2";
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)("signature-widget", attributes === null || attributes === void 0 ? void 0 : attributes.className, tokens_1.lightTheme), contentEditable: false, style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.maxColumnCount] = maxColumnCount, _b)) }),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", wrap: true, className: styles.container({ maxCol: useMaxCol }) }, acceptStore.accepterSlots.map(function (accepter, index) {
            var _a;
            var isSlotFilled = isSlotFilledAnywhere(index);
            return (react_1.default.createElement("div", { id: "agreement-initials-signature-".concat(storeIndex, "-").concat(index), key: index },
                react_1.default.createElement(SignatureSlot_1.SignatureSlot, { name: accepter.name, isMultiAccept: acceptStore.accepterSlots.length > 1, hasPrefilledName: acceptStore.hasPrefilledName(index), isPrintMode: isPrintMode, data: (_a = accepter.signature) !== null && _a !== void 0 ? _a : null, onClear: function () { return handleClearSignature(index); }, onChange: function (data) { return handleChangeSignature(data, index); }, type: SignatureSlot_1.SlotType.Signature, isAccepted: accepter.isAccepted, dateStamp: accepter.acceptedAt.toLocaleString(), isEditable: isAcceptedInCurrentSession
                        ? false
                        : !accepter.isAccepted && !AcceptFlowGlobalStore_1.default.getInstance().isSlotLockedInAnyStore(index), isCritical: accepter.isCritical, onSlotClick: function () { return handleSlotClick(index); }, isSlotFilledAnywhere: isSlotFilled, labelStyle: "name" })));
        }))));
});
var WrappedSignatureWidget = function (_a) {
    var attributes = _a.attributes, di = _a.di, isPrintMode = _a.isPrintMode, index = _a.index;
    var isClientSide = typeof document !== "undefined";
    if (!isClientSide || !di) {
        return null;
    }
    var container = new inversify_1.Container({ skipBaseClassChecks: true });
    var globalDataStore = AcceptFlowGlobalStore_1.default.getInstance();
    var existingDataStoreInstance = globalDataStore.getDataStoreInstance("signature-".concat(index));
    var guidedFlowStore = GuidedFlowStore_1.GuidedFlowStore.getInstance();
    if (existingDataStoreInstance) {
        container.bind("acceptersDataStore").toConstantValue(existingDataStoreInstance);
    }
    else {
        var acceptersDataStore = new AcceptersDataStore_1.AcceptersDataStore(di.get("$rootScope"));
        container.bind("acceptersDataStore").toConstantValue(acceptersDataStore);
        AcceptFlowGlobalStore_1.default.getInstance().registerDataStore(acceptersDataStore, "signature-".concat(index));
    }
    container.bind("guidedFlowStore").toConstantValue(guidedFlowStore);
    var widgetId = attributes["data-widget-id"];
    return (react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
        react_1.default.createElement(DIProvider_1.default, { container: function () { return container; } },
            react_1.default.createElement(SignatureWidget, { attributes: attributes, isPrintMode: isPrintMode, widgetId: widgetId }))));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(WrappedSignatureWidget, { componentName: "SignatureWidget" });
